module.exports = "/images/vendor/jstree/dist/themes/default/40px.png?7d2fda9cfc3a739e506561b08e4f019f";